


































































import Vue, { PropType } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import { ValidationObserver } from 'vee-validate';
import { GiftEntity } from '@/entities/gift.entity';
import GiftService from '@/services/gift.service';

@Component<EditBulletinComment>({})
export default class EditBulletinComment extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  giftMessagePayload: Partial<GiftEntity> = {
    message: null,
    gift: null,
    staffToId: null,
  };

  @Prop({ type: Boolean })
  value: boolean;

  @Prop({ type: Object as PropType<GiftEntity> })
  gift: GiftEntity;

  @Watch('value')
  async onPropertyChanged() {
    await this.$nextTick();
    this.$refs.form.reset();
    this.giftMessagePayload.message = this.gift.message;
  }

  async created(): Promise<void> {
    this.giftMessagePayload.message = this.gift.message;
    this.giftMessagePayload.gift = this.gift.gift;
    this.giftMessagePayload.staffToId = this.gift.staffToId;
  }

  @UseService(GiftService)
  service: GiftService;

  async editGift(): Promise<void> {
    await this.service.updateOne(this.gift.id, this.giftMessagePayload);
    this.$refs.form.reset();
    this.$emit('input', !this.value);
  }
}
